import React from "react";
import { Box, InputLabel, TextField, Typography } from "@mui/material";

interface Props {
  priorAuthorizationNumber: string;
  onChange: (value: string) => void;
  claimStatus: string;
  isRequired?: boolean;
}

const PriorAuthorizationNumber: React.FC<Props> = ({
  priorAuthorizationNumber,
  onChange,
  claimStatus,
  isRequired = false,
}) => {
  return (
    <Box
      sx={{
        backgroundColor: "white",
        padding: "20px",
        height: "250px",
      }}
    >
      <Typography
        sx={{
          color: "#707070",
          fontWeight: 700,
          fontSize: "14px",
          lineHeight: "26px",
        }}
      >
        Prior Authorization Number
      </Typography>
      <p
        style={{
          color: "#707070",
          fontSize: "12px",
          lineHeight: "16px",
          marginBlockStart: "0px",
          marginBlockEnd: "0px",
          marginBottom: "15px",
          marginTop: "5px",
          fontWeight: 400,
        }}
      >
        {isRequired
          ? "Prior authorization is required and the payer will provide an assigned number. Enter this number here for authorized services rendered."
          : "When prior authorization is required, the payer will provide an assigned number. Enter this number here for authorized services rendered."}
      </p>

      <InputLabel
        htmlFor="priorAuthorizationNumber"
        sx={{
          color: "#A29D9B",
          fontWeight: 700,
          fontSize: "12px",
          lineHeight: "18px",
          marginBottom: "5px",
        }}
      >
        Authorization Number{isRequired && "*"}
      </InputLabel>

      <Box className="field-container" sx={{ marginLeft: "0px" }}>
        <TextField
          id="priorAuthorizationNumber"
          size="small"
          value={priorAuthorizationNumber}
          className="the-field"
          required={isRequired}
          autoComplete="off"
          variant="outlined"
          placeholder="XX-XXXXXXXXXXX"
          disabled={
            claimStatus === "submitted" || claimStatus === "pending_submission"
          }
          onChange={(e) => {
            const priorAuthorizationNumber = e.target.value.replace(/\D/g, "");
            onChange(priorAuthorizationNumber);
          }}
          sx={{
            width: "100% !important",
          }}
          slotProps={{ htmlInput: { inputMode: "numeric" } }}
        />
      </Box>
    </Box>
  );
};

export default PriorAuthorizationNumber;
